module.exports = __webpack_public_path__ + "img/klaerschlamm-grafik.d97c6b20.png";